export default "__VITE_ASSET__CXLqcytJ__"